import { render } from "./PeriodsList.vue?vue&type=template&id=24c9d1e4&scoped=true&ts=true"
import script from "./PeriodsList.vue?vue&type=script&lang=ts"
export * from "./PeriodsList.vue?vue&type=script&lang=ts"

import "./PeriodsList.vue?vue&type=style&index=0&id=24c9d1e4&lang=scss&scoped=true"

import exportComponent from "/var/www/kun/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24c9d1e4"]])

export default __exports__